import { get } from "lodash";

import { HomepageHeaderBanner } from "@urp/derby-banner/src/types";

export const getHomepageDerbyBanner = (store: unknown): HomepageHeaderBanner =>
  get(store, "home.derbyBanner", undefined);

export const getDerbyBannerImageToggle = (store: unknown) =>
  get(store, "capi.featureToggles.useDerbyBannerImage", false);
